module.exports = __webpack_public_path__ + "static/img/200.d30bff5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201029/200.jpg
// module id = qo2A
// module chunks = 0